module.exports = __webpack_public_path__ + "img/schlesien-karte.1811fec2.jpg";